import React from 'react';
import { useStyles, cx } from '../../../lib/styles';
import Typography from '../Typography';
import calloutStyles from './Callout_styles';

export interface CalloutProps {
  /** A title to display in the callout's heading. */
  title?: string;

  /** Whether the callout should stick at the top of the screen. */
  sticky?: boolean;

  /** The content of the callout. */
  children?: React.ReactNode;

  /** Any classname overrides. */
  className?: string;
}

/**
 * A callout. Generally used as a low-impact card on side-rails.
 */
export const Callout = (props: CalloutProps) => {
  const { title, children, className } = props;
  const styles = useStyles(calloutStyles(props));

  return (
    <div className={cx('Callout', styles.callout, className)}>
      {/* {title && (
        <div className={styles.calloutHeading}>
          <Typography color={`primary`}>
            <h3>{title}</h3>
          </Typography>
        </div>
      )} */}

      {children && <div className={styles.calloutBody}>{children}</div>}
    </div>
  );
};

export default Callout;
